import { Temporal } from "@js-temporal/polyfill";

export interface WallClock {
  instant(): Temporal.Instant;
}

export class SystemWallClock implements WallClock {
  instant(): Temporal.Instant {
    return Temporal.Now.instant();
  }
}

export class MutableWallClock implements WallClock {
  #value: Temporal.Instant;
  constructor(value: Temporal.Instant) {
    this.#value = value;
  }
  instant(): Temporal.Instant {
    return this.#value;
  }
  set(value: Temporal.Instant): void {
    this.#value = value;
  }
  advance(seconds: number): void {
    this.#value = this.#value.add({ seconds });
  }
}

export class GameClock {
  static readonly timeZone = "America/New_York";
  constructor(readonly wallClock: WallClock) {}
  instant(): Temporal.Instant {
    return this.wallClock.instant();
  }
  nowZoned(): Temporal.ZonedDateTime {
    return this.instant().toZonedDateTimeISO(GameClock.timeZone);
  }
  formatHud(): string {
    const z = this.nowZoned();
    const weekday = z.toLocaleString("en-US", { weekday: "short" }).toUpperCase();
    const month = z.toLocaleString("en-US", { month: "short" }).toUpperCase();
    const hour = z.hour % 12 || 12;
    return `${weekday} · ${month} ${z.day} · ${hour}:${String(z.minute).padStart(2, "0")} ${z.hour < 12 ? "AM" : "PM"}`;
  }
}

export function clockFromQuery(search: string, production: boolean): GameClock {
  if (!production) {
    const raw = new URLSearchParams(search).get("clock");
    if (raw) {
      try {
        return new GameClock(new MutableWallClock(Temporal.ZonedDateTime.from(raw).toInstant()));
      } catch {
        /* system clock */
      }
    }
  }
  return new GameClock(new SystemWallClock());
}
